import { NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { JuniorCampInfo, JuniorPriceList } from '../../models';
import { Company, CompanyEnum } from '../../models/company.model';
import { JuniorCampAgesPipe } from '../../pipes/junior-camp-ages.pipe';
import { JuniorCampsSchoolDescriptionPipe } from '../../pipes/junior-camps-school-description.pipe';
import { SubjectEnum } from '../../utils/notes.utils';
import { SchoolHeaderComponent } from '../school-header/school-header.component';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-junior-camps-header',
  imports: [SchoolHeaderComponent, NgIf, JuniorCampAgesPipe, JuniorCampsSchoolDescriptionPipe],
  templateUrl: './junior-camps-header.component.html',
  styleUrls: ['./junior-camps-header.component.scss'],
})
export class JuniorCampsHeaderComponent implements OnInit {
  @Input() juniorCamp: JuniorPriceList | undefined;
  @Input() company: Company = CompanyEnum.KIL;
  @Input() applicationForms = [];
  juniorCampInfo: JuniorCampInfo | undefined;
  includedInPackageNote: string | undefined;

  ngOnInit(): void {
    this.juniorCampInfo = this.juniorCamp.juniorCampInfo;
    const note = this.juniorCamp?.notes?.find((note) => note?.subject === SubjectEnum.CAMP_INCLUDED_IN_PACKAGE)?.text;
    if (note) {
      this.includedInPackageNote = `Included in the package: ${note}`;
    }
  }
}
